<p-toast></p-toast>
<pv-header
  *ngIf="isHeaderVisible"
  [searchVisible]="searchVisible"
  [styleClass]="isHeaderVisible ? '' : 'hidden'"></pv-header>
<div class="overflow-x-hidden w-screen min-height-router">
  <router-outlet></router-outlet>
</div>
<hdfc-rupay-footer *ngIf="isFooterVisible"></hdfc-rupay-footer>
